/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const HandStar = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M20.5 13.5H19.5V20.5H20.5V13.5ZM18 12V19.31L11.285 20.2053C11.0937 20.2308 10.9 20.2316 10.7085 20.2077L3.86571 19.3523C3.92211 19.1893 4.00145 19.0246 4.10865 18.8757C4.3446 18.548 4.74444 18.2499 5.5 18.2499H9.43445V18.2519L9.44769 18.2499H9.55735L16.114 17.2412L15.886 15.7587L15.8361 15.7663L15.8361 15.7663L10.9344 16.5079V16.0252C10.9344 15.927 10.9919 15.8379 11.0814 15.7974L15.7191 13.6999C16.0104 13.5682 16.3265 13.5 16.6463 13.5H17.9994V12H16.6463C16.1133 12 15.5865 12.1136 15.1009 12.3332L10.4633 14.4307C9.83693 14.714 9.43445 15.3377 9.43445 16.0252V16.7499H5.5C4.25556 16.7499 3.4054 17.2853 2.89135 17.9992C2.40484 18.6749 2.25 19.4633 2.25 19.9999V20.662L10.5225 21.6961C10.8416 21.736 11.1645 21.7347 11.4832 21.6922L18 20.8232V22H22V12H18Z"
                        fill={color}
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8.38805 2.2822C8.26374 1.90593 7.73626 1.90593 7.61195 2.2822L5.81818 5.69244L2.40983 6.12705L2.35278 6.13072C2.0025 6.17661 1.86601 6.64112 2.16233 6.86834L4.63409 9.53858L3.92652 13.4515L3.9122 13.5035C3.83583 13.8639 4.25073 14.1479 4.5584 13.9158L8 11.9049L11.4416 13.9158L11.4862 13.9455C11.8027 14.1295 12.198 13.8182 12.0735 13.4515L11.2723 9.70383L13.8377 6.86834L13.8809 6.83058C14.1323 6.5802 13.9623 6.12705 13.5902 6.12705L10.1818 5.69244L8.38805 2.2822ZM11.3732 7.3565L9.21769 7.08164L8 4.76663L6.78231 7.08164L4.6549 7.35292L6.24335 9.06892L5.81366 11.4451L8 10.1676L10.0998 11.3946L9.64496 9.26673L11.3732 7.3565Z"
                        fill={color}
                    />
                </svg>
        );
    };
